import { useQuery } from "@tanstack/react-query";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { useStandaloneBookingFlow } from "~/features/book-appointment/useStandaloneBookingFlow";
import { useStore } from "~/mobx/utils/useStore";

export const WithClinicPhoneNumber = observer(function WithClinicPhoneNumber({
  children,
}: {
  children: React.ReactNode;
}) {
  const store = useStore();

  // We have two different flows for the booking, we have to select an clinicId
  // depending on the flow.
  const { clinicId: standaloneClinicId } = useStandaloneBookingFlow();
  const appClinicId = store.bookingStore.clinicId;

  const clinicId = appClinicId ?? standaloneClinicId;

  // Clean the phone number when the clinicId changes
  useEffect(() => {
    if (clinicId) {
      store.uiStore.setClinicPhoneNumber("");
    }
  }, [clinicId, store.uiStore]);

  // TODO: handle loading and error states
  const query = useQuery({
    queryKey: ["clinic", clinicId],
    queryFn: async () => {
      const clinic = await store.clinicsStore.getClinic(clinicId as string);

      return clinic;
    },
    enabled: !!clinicId,
  });

  useEffect(() => {
    if (query.data && query.data.phone) {
      store.uiStore.setClinicPhoneNumber(query.data.phone);
    }
  }, [query.data, store.uiStore]);

  return children;
});
